import BannerEmailCheck from './banner-email-check';

export default BannerEmailCheck;
